export default "__VITE_ASSET__nqog5DRj__"